import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { propFuncList, propShape } from '../../../helpers/custom-prop-types';
import FileAndTitleArrayFieldComponent from './FileAndTitleArrayFieldComponent';
class RelatedPortfolioFieldsAndLabel extends Component {
    constructor() {
        super(...arguments);
        this.onClickDelete = (e) => {
            const { fields } = this.props;
            const index = parseInt(e.currentTarget.value, 10);
            fields.remove(index);
            if (fields.length === 1) {
                fields.push({});
            }
        };
        this.onClickAdd = () => {
            const { fields } = this.props;
            fields.push({});
        };
    }
    render() {
        const { fields, thisForm, validateFile, validateTitle } = this.props;
        return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx("h3", { children: "\u30DD\u30FC\u30C8\u30D5\u30A9\u30EA\u30AA" }), _jsx("div", Object.assign({ className: 'presen-result-wrapper is-flex' }, { children: fields.map((field, index) => (_jsx(FileAndTitleArrayFieldComponent, { field: field, fields: fields, filePropName: 'uploadFile', index: index, onClickDelete: this.onClickDelete, thisForm: thisForm, thumbnailPropName: 'uploadFileThumbnail', validateFile: validateFile, validateTitle: validateTitle }, field))) })), _jsx("button", Object.assign({ className: 'btn btn-default small wide', onClick: this.onClickAdd, type: 'button' }, { children: "\u8FFD\u52A0\u3059\u308B" }))] })));
    }
}
RelatedPortfolioFieldsAndLabel.propTypes = {
    fields: propShape().isRequired,
    thisForm: propShape().isRequired,
    validateFile: propFuncList().isRequired,
    validateTitle: propFuncList().isRequired,
};
export default RelatedPortfolioFieldsAndLabel;
